// link 分享链接
// describe 分享描述

// Facebook分享
export const shareFB = (link = window.location.href, shareTitle = document.title, shareImage) => {
    // 构建 Facebook 分享链接，包括标题和图片参数
    var facebookShareUrl = 'https://www.facebook.com/sharer/sharer.php' +
        '?u=' + encodeURIComponent(link) +
        '&title=' + encodeURIComponent(shareTitle) +
        '&picture=' + encodeURIComponent(shareImage);

    // 使用 window.open() 方法在新窗口中打开 Facebook 分享链接
    window.open(facebookShareUrl, '_blank', 'width=600,height=400,center',);
}

// Line分享
export const shareLine = (link = window.location.href, describe = document.title) => {
    window.open(`https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(link)}&t=${encodeURIComponent(describe)}`);
}

// Twitter分享
export const shareTwitter = (link = window.location.href, describe = document.title) => {
    window.open(`https://twitter.com/intent/tweet?url=${encodeURIComponent(link)}&text=${encodeURIComponent(describe)}`);
}

// WhatsApp分享
export const shareWhatsapp = (link = window.location.href, describe = document.title) => {
    const content = `${describe}\n${link}\n`;
    location = `whatsapp://send?text=${encodeURIComponent(content)}`;
}

// DC分享
export const shareDc = (link = window.location.href) => {
    window.open(link);
}
